import { render, staticRenderFns } from "./deviceNum.vue?vue&type=template&id=cc83f42c&scoped=true&"
import script from "./deviceNum.vue?vue&type=script&lang=js&"
export * from "./deviceNum.vue?vue&type=script&lang=js&"
import style0 from "./deviceNum.vue?vue&type=style&index=0&id=cc83f42c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc83f42c",
  null
  
)

export default component.exports